import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Routes, { CreateRecipePageSteps } from 'config/routes';
import useSaveFrom from 'hooks/useSaveFrom';

import useAuthentication from 'domain/authentication/useAuthentication';

import useIdempotencyToken from './useIdempotencyToken';
import RecipeContentMapper from 'services/mappers/recipes/RecipeContentMapper';

const orderedRoutes = [
  CreateRecipePageSteps.title,
  CreateRecipePageSteps.ingredients,
  CreateRecipePageSteps.timeToPrepare,
  CreateRecipePageSteps.directions,
  CreateRecipePageSteps.additionalData,
  CreateRecipePageSteps.confirmation,
  CreateRecipePageSteps.request,
];
const _findIndexStep = (step) => {
  const index = orderedRoutes.indexOf(step);
  if (index === -1) return 0;
  return index;
};

const CreateRecipeSerializedKey = 'create_recipe_serialized';

const useCreatePageRecipePage = () => {
  const { step } = useParams();
  const history = useHistory();
  const from = useSaveFrom('create_recipe_from');
  const { idempotencyToken } = useIdempotencyToken();
  const { isAuthenticated } = useAuthentication();

  const [indexStep, setIndexStep] = useState(_findIndexStep(step));

  const [recipe, setRecipe] = useState(
    sessionStorage.getItem(CreateRecipeSerializedKey)
      ? RecipeContentMapper.mapStringToUIModel(
          sessionStorage.getItem(CreateRecipeSerializedKey)
        )
      : {
          title: '',
          ingredients: [],
          timeToPrepare: '',
          directions: [],
          additionalData: {
            description: '',
            servings: '',
            coverPhotoURL: '',
            nutricionalData: {
              calories: '',
              protein: '',
              carbohydrate: '',
              fat: '',
            },
          },
        }
  );

  useEffect(() => {
    setIndexStep(_findIndexStep(step));
  }, [step]);

  useEffect(() => {
    sessionStorage.setItem(
      CreateRecipeSerializedKey,
      RecipeContentMapper.mapUIModelToString(recipe)
    );

    return () => {
      sessionStorage.removeItem(CreateRecipeSerializedKey);
    };
  }, [recipe]);

  const goToNextStep = () => {
    history.push(Routes.createRecipe(orderedRoutes[indexStep + 1]));
  };

  const goToPreviousStep = () => {
    if (!indexStep) exitPage();
    else history.push(Routes.createRecipe(orderedRoutes[indexStep - 1]));
  };

  const exitPage = () => history.replace(from);

  return {
    step,
    recipe,
    setRecipe,
    goToNextStep,
    goToPreviousStep,
    idempotencyToken,
    exitPage,
    isAuthenticated,
  };
};

export default useCreatePageRecipePage;
